export default __webpack_public_path__ + "a6fe4ec.png";